import { Fragment } from "@wordpress/element";
import { TextControl, PanelBody, PanelRow } from "@wordpress/components";
import { InspectorControls, InnerBlocks, RichText } from '@wordpress/block-editor';
import { __ } from "@wordpress/i18n";

const Accordeon = {
  title: __('Accordeon'),
  description: __('Accordeon content block for the ABS theme'),
  icon: 'editor-justify',
  attributes: {
    title : {
      type:   'string',
    },
    anchor : {
      type:   'string',
    },
  },
  supports: {
    customClassName: false,
  },
  edit({ className, attributes, setAttributes, isSelected }) {
    const { title, anchor } = attributes;

    return (
      <Fragment>
        <div className={className}>
          <div className="accordeon__header">
            <div className="accordeon__header__label">
              <RichText
                tagName="h2"
                value={ title }
                placeholder={ __('Insert accordeon title') }
                allowedFormats={[]}
                onChange={nextTitle => setAttributes({ title: nextTitle })}
              />
            </div>
          </div>
          <div className="accordeon__body">
            <InnerBlocks />
          </div>
        </div>
        <InspectorControls>
          <PanelBody
            title={ __('Anchor for direct linking') }
            initialOpen={true}
          >
            <PanelRow>
              <TextControl
                label={ __('Anchor ID') }
                value={ anchor }
                onChange={ ( value ) => setAttributes( { anchor: value } ) }
              />
            </PanelRow>
          </PanelBody>
        </InspectorControls>
      </Fragment>
    );
  },

  save({ className, attributes }) {
    const { title, anchor } = attributes;
    const anchorAttr = (anchor !== undefined) ? anchor : null ;

    return (
      <div className={ className } id={ anchorAttr }>
        <div className="accordeon__header">
          <div className="accordeon__header__label">
            {title && (
              <RichText.Content tagName="h2" value={ title } />
            )}
          </div>
        </div>
        <div className="accordeon__body">
          <InnerBlocks.Content />
        </div>
      </div>
    );
  },
  deprecated: [{
    attributes: {
      title : {
        type:   'string',
      },
    },
    save({ className, attributes }) {
      const { title } = attributes;

      return (
        <div className={ className }>
          <div className="accordeon__header">
            <div className="accordeon__header__label">
              {title && (
                <RichText.Content tagName="h2" value={ title } />
              )}
            </div>
          </div>
          <div className="accordeon__body">
            <InnerBlocks.Content />
          </div>
        </div>
      );
    }
  }]
};

export default Accordeon;
